import AhoyEvent from 'shared/ahoy_event';

export default class Tracker {
  static data() {
    return window.player.data();
  }

  static playbackEnv() {
    return window.player.env().currentEnv();
  }

  static sendEndedEvent() {
    const properties = Object.assign({}, {
      blocker_type: 'livestreaming_end',
      content_id: this.data().videoId(),
      content_type: 'livestreaming',
      is_premier: this.data().isPremier(),
      play_uuid: this.data().playUUID()
    }, this.playbackEnv());

    AhoyEvent.send('PLAYBACK::BLOCKER', properties);
  }
}
